import { type FC } from "react";

import { Badge } from "@mantine/core";
import { clsx } from "clsx";

import { ProgramPayoutStatus } from "../../../models";
import { formatMonthDay } from "../../../utils";

import styles from "./EnrolledProgram.module.css";
import { PaidOn, StatusInProgress, StatusNone, StatusPaid, StatusPending } from "./messages.generated";

interface PayoutStatusChipProps {
    status: ProgramPayoutStatus;
    paidOn?: string | null;
}

const CHIPS: Record<ProgramPayoutStatus, { className: string; Label: FC } | null> = {
    [ProgramPayoutStatus.InProgress]: { className: styles.pendingStatus, Label: StatusInProgress },
    [ProgramPayoutStatus.Pending]: { className: styles.pendingStatus, Label: StatusPending },
    [ProgramPayoutStatus.Paid]: { className: styles.paidStatus, Label: StatusPaid },
    // Unconfirmed state: the amount shows without a chip.
    [ProgramPayoutStatus.Recorded]: null,
    [ProgramPayoutStatus.None]: { className: styles.neutralStatus, Label: StatusNone },
};

export const PayoutStatusChip: FC<PayoutStatusChipProps> = ({ status, paidOn = null }) => {
    const chip = CHIPS[status];
    return (
        chip && (
            <Badge className={clsx(styles.statusChip, chip.className)}>
                {status === ProgramPayoutStatus.Paid && paidOn ? (
                    <PaidOn date={formatMonthDay(paidOn)} />
                ) : (
                    <chip.Label />
                )}
            </Badge>
        )
    );
};
